export const USERS = '/users'
export const USERS_GET = '/users/get'
export const USER_BILLING_DETAILS = '/users/billing'
export const USERS_CREATE = '/users/create'
export const USERS_AND_PATIENTS = '/users/patients'
export const USER_BILLING_STATEMENT = 'users/download-billing-statement'
export const PATIENTS_CREATE = '/patients/create'

export const getUserInfoById = (userId: string): string =>
  `${USERS}/${userId}/details`

export const getUserBillingDetailsRoute = (id: string): string =>
  `${USER_BILLING_DETAILS}?userId=${id}`

export const getConsentPdfRoute = (patientId: string): string =>
  `/patients/${patientId}/consent-pdf`

export const sendConsentEmailRoute = (patientId: string): string =>
  `/patients/${patientId}/consent`

export const getUserB2BDetails = (email: string): string =>
  `users/exists?email=${encodeURIComponent(email)}`

export const updateUserRoute = (userId: string): string => `users/${userId}`

export const verifyCodeConsentRoute = (code: string): string =>
  `/patients/consent/${code}/verify`

export const verifyConsentFromVFDRoute = (taskId: string): string =>
  `/patient-tasks/consent/${taskId}/verify`

export const signCodeConsentRoute = (code: string): string =>
  `/patients/consent/${code}/sign`

export const signConsentFromVFDRoute = (patientId: string): string =>
  `/patient-tasks/consent/${patientId}/sign`

export const geTransactionHistoryRoute = (
  responsiblePartyEhrId: number,
  { startDate, endDate }: Record<string, string>
): string =>
  `/payment-receipts?startDate=${startDate}&endDate=${endDate}&responsiblePartyEhrId=${responsiblePartyEhrId}`

export const getPaymentPdfRoute = (paymentId: string): string =>
  `/payment-receipts/${paymentId}/download`

export const getSessionBillingStatementRoute = (params: {
  userId: string
  patientId: string
  ehrVisitId: string
}): string =>
  `${USER_BILLING_STATEMENT}?patientId=${params.patientId}&ehrVisitId=${params.ehrVisitId}&userId=${params.userId}`

export const createUserSkippingEmailVerification = `${USERS}/create-skip-email-verification`
